export default __webpack_public_path__ + "static/media/import-csv-example-en.881c7733.csv";